module.exports = __webpack_public_path__ + "541bc349a0407e45c494f879cf986e.png";